import { Button, Card, Divider } from '@blueprintjs/core';
import { ace, loan_application } from '@axo/shared/data-access/types';
import { dateToRelativeTime } from '../../utils/dateToRelativeTime.ts';
import { SMSIcon } from '../CommunicationCard/CommunicationItem';
import styles from './Notification.module.css';
import { useApplicationDetail } from '@axo/shared/data-access/hooks';
import { parseTransferNotification } from './parseTransferNotification';
import { TransferNotification } from './TransferNotification';

export function Notification({
  notification,
  onClick,
  action,
}: {
  notification: ace.Notification;
  onClick: (loanApplication?: loan_application.LoanApplication) => void;
  action?: { label: string; onClick: () => void; isLoading: boolean };
}) {
  const loanApplication = useApplicationDetail(notification.LoanApplicationID);
  const transferData = parseTransferNotification(notification.Body);

  if (transferData) {
    return (
      <TransferNotification
        notification={notification}
        senderInitials={transferData.senderInitials}
        humanReadableID={loanApplication.data?.HumanReadableID ?? undefined}
        onClick={() => onClick(loanApplication.data)}
        action={action}
      />
    );
  }

  return (
    <Card
      onClick={() => onClick(loanApplication.data)}
      className={styles.card}
      interactive
    >
      <div className={styles.topBar}>
        <span>
          <SMSIcon inbound={true} />
          <span className={styles.title}>{notification.Title}</span>
        </span>
        <span>{dateToRelativeTime(notification.CreatedAt)}</span>
      </div>
      <Divider />
      <div className={styles.body}>
        <div>{notification.Body}</div>
      </div>
      <div className={styles.bottomRow}>
        {action && (
          <Button
            className={styles.actionButton}
            minimal
            small
            intent={'primary'}
            onClick={(e) => {
              e.stopPropagation();
              action.onClick();
            }}
            loading={action.isLoading}
          >
            {action.label}
          </Button>
        )}
      </div>
    </Card>
  );
}
